import { render, staticRenderFns } from "./ViewerHeader.vue?vue&type=template&id=2785b2c6&scoped=true"
import script from "./ViewerHeader.vue?vue&type=script&lang=js"
export * from "./ViewerHeader.vue?vue&type=script&lang=js"
import style0 from "./ViewerHeader.vue?vue&type=style&index=0&id=2785b2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2785b2c6",
  null
  
)

export default component.exports